"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PSResult = exports.PSVersion = exports.PSPath = void 0;
exports.PSPath = {
    Scan: "scan",
};
exports.PSVersion = {
    NONE: "",
};
exports.PSResult = {
    Success: "SUCCESS",
    Failed: "FAILED",
};
